module.exports = __webpack_public_path__ + "img/pk.d89ce3c3.svg";